export default "__VITE_ASSET__Y3_H16Et__"